<template>
    <MainLayout selectMenu="1-1" siderMenu="17-1" sideBar="machine">
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else>            
            <Tabs v-model="modificationMode" type="card" class="custom-tabs">
                <TabPane :label="getTranslation('d014')" name="m1" class="custom-tabpane">
                    <Row class="menu-line" type="flex">
                          <Col flex="1" class="menu-actions" >
                        <Button type="info" size="small"  icon="md-cloud-download" @click.native="exportRecord">{{ 
                            getTranslation("k025") }}</Button>
                        </Col>
                        <Col flex="12" class="search-part">
                        {{ getTranslation('k221') }}:&nbsp;<DatePicker size="small" transfer type="daterange" placement="bottom-end"
                            :placeholder="getTranslation('k220')" style="width: 210px" v-model="selectDate"
                            format="yyyy-MM-dd">
                        </DatePicker>&nbsp;
                        <Input v-model="programId" @on-enter="queryData()" size="small" style="width:100px" :placeholder="getTranslation('b006')" />&nbsp;
                        <Tooltip :content="getTranslation('k176')" placement="bottom" theme ="light" :transfer="true">
                        <Button type="primary" size="small" @click.native="queryData()" shape="circle" icon="ios-search"></Button>
                        </Tooltip>
                        &nbsp;
                        <Tooltip :content="getTranslation('e020')" placement="bottom" theme ="light" :transfer="true">
                        <Button type="error" size="small"  @click.native="emptyQuery()" shape="circle"
                            icon="ios-refresh"></Button>
                        </Tooltip>
                        </Col>
                    </Row>
                    <Row type="flex" class="action-row menu-actions pagination-container" >
                        <Col class="query-conditions-col " flex="2">
                        <span class="query-prefix">{{getTranslation('p094')}}：</span>
                        <span class="query-tag" v-for="(cond, idx) in querySystemConditions" :key="idx">
                            <span class="tag-label">{{ cond.label }}</span>
                            <span class="tag-value">{{ cond.value }}</span>
                        </span>
                        <span v-if="querySystemConditions.length === 0" class="query-tag query-tag-all">
                            <span class="tag-value">{{ getTranslation('k236') }}</span>
                        </span>
                        </Col>
                        <Col flex="1">
                         <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
                            @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
                            :page-size-opts=pageSizeAry>{{
                                getTranslation('c010') }} {{ total }}
                            {{ getTranslation('c011') }}</Page>                        
                        </Col>
                    </Row>
                    <div class="table-wrapper" :style="dynamicHeightStyle">
                    <div class="table-header-fixed">                                 
                    <Row class="table-header" type="flex">
                        <Col flex="1" class="table-cell">{{ getTranslation('k221') }}
                        </Col>
                        <Col flex="1" class="table-cell">{{ getTranslation('k222') }}
                        </Col>
                        <Col flex="1" class="table-cell">{{ getTranslation('b006') }}
                        </Col>
                        <Col flex="2" class="table-cell">{{ getTranslation('b007') }}
                        </Col>
                        <Col flex="3" class="table-cell">{{ getTranslation('k257') }}
                        </Col>
                        <Col flex="2" class="table-cell">{{ getTranslation('k239') }}
                        </Col>
                        <Col flex="2" class="table-cell">{{ getTranslation('k240') }}
                        </Col>
                        <Col flex="1" class="table-cell">{{ getTranslation('u008') }}
                        </Col>
                    </Row> 
                    </div>
                    <div class="table-body">                                         
                    <Row v-for="(item, index) in modification" :key="item.id"
                        :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex">
                        <Col flex="1" class="table-cell">{{ getDate(item.created_string) }}
                        </Col>
                        <Col flex="1" class="table-cell">{{ getTime(item.created_string) }}
                        </Col>
                        <Col flex="1" class="table-cell">{{ item.program_id }}
                        </Col>
                        <Col flex="2" class="table-cell">{{ item.program_name }}
                        </Col>
                        <Col flex="3" class="table-cell">{{ item.content }}
                        </Col>
                        <Col flex="2" class="table-cell">{{ item.original }}
                        </Col>
                        <Col flex="2" class="table-cell">{{ item.present }}
                        </Col>
                        <Col flex="1" class="table-cell">{{ item.created_nick_name }}
                        </Col>
                    </Row>
                    </div>
                    </div>
                    <Row type="flex" class="menu-actions">
                      
                        <Col flex="1">
                        <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
                            @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
                            :page-size-opts=pageSizeAry>{{
                                getTranslation('c010') }} {{ total }}
                            {{ getTranslation('c011') }}</Page>
                        </Col>
                    </Row>
                </TabPane>
                <TabPane :label="getTranslation('d015')" name="m2" class="custom-tabpane">
                    <Row class="menu-line" type="flex">
                        <Col flex="1" class="menu-actions" >
                        <Button type="info" size="small"  icon="md-cloud-download" @click.native="exportSpotModification">{{
                            getTranslation("k025") }}</Button>
                        </Col>
                        <Col flex="12" class="search-part">
                        {{ getTranslation('k221') }}:&nbsp;<DatePicker size="small" transfer type="daterange" placement="bottom-end"
                            :placeholder="getTranslation('k220')" style="width: 210px" v-model="selectDate"
                            format="yyyy-MM-dd">
                        </DatePicker>&nbsp;
                        <Input v-model="spotId" @on-enter="queryProdSpotData()" size="small" style="width:150px" :placeholder="getTranslation('k259')" />&nbsp;
                        <Input v-model="operator" @on-enter="queryProdSpotData()" size="small" style="width:100px" :placeholder="getTranslation('u008')" />&nbsp;
                        <Select :transfer="true" size="small" style="width:100px" :filterable="true"
                            :placeholder="getTranslation('m034')" v-model="actionType"
                            :not-found-text="getTranslation('b038')">
                            <Option v-for="(item, index) in AllActionMap" :value="item.key" :key="index">{{ item.val }}</Option>
                        </Select>&nbsp;
                        <Tooltip :content="getTranslation('k176')" placement="bottom" theme ="light" :transfer="true">
                        <Button type="primary" size="small"  @click.native="queryProdSpotData();" shape="circle"
                            icon="ios-search"></Button></Tooltip>&nbsp;
                        <Tooltip :content="getTranslation('e020')" placement="bottom" theme ="light" :transfer="true">
                        <Button type="error" size="small"  @click.native="emptyProdSpotQuery()" shape="circle"
                            icon="ios-refresh"></Button></Tooltip>
                        </Col>
                    </Row>
                    <Row type="flex" class="action-row menu-actions pagination-container" >
                        <Col class="query-conditions-col " flex="2">
                        <span class="query-prefix">{{getTranslation('p094')}}：</span>
                        <span class="query-tag" v-for="(cond, idx) in queryModifyConditions" :key="idx">
                            <span class="tag-label">{{ cond.label }}</span>
                            <span class="tag-value">{{ cond.value }}</span>
                        </span>
                        <span v-if="queryModifyConditions.length === 0" class="query-tag query-tag-all">
                            <span class="tag-value">{{ getTranslation('k236') }}</span>
                        </span>
                        </Col>
                        <Col flex="1">
                         <Page class="page-line" :total="prodSpotTotal" :current="prodSpotCurrent"
                            :page-size="prodSpotPageSize" show-total @on-change="handleProdSpotPageChange"
                            @on-page-size-change="handleProdspotPageSizeChange" :show-sizer="true"
                            :page-size-opts=pageSizeAry>{{
                                getTranslation('c010') }} {{ prodSpotTotal }}
                            {{ getTranslation('c011') }}</Page>                      
                        </Col>
                    </Row>
                    
                    <!-- 使用table格式重新设计 -->
                    <div class="table-container table-wrapper" :style="dynamicHeightStyle">                        
                        <table class="modification-table" style="width: 100%;">                            
                            <thead class="table-header-fixed" ref="tableHeader">
                                <tr class="table-row">
                                <th class="table-header" rowspan="2">{{ getTranslation('k222') }}</th>
                                <th class="table-header" rowspan="2">{{ getTranslation('k259') }}</th>
                                <th class="table-header" rowspan="2">{{ getTranslation('u008') }}</th>
                                <th class="table-header" rowspan="2">{{ getTranslation('d016') }}</th>
                                <th class="table-header" colspan="16">{{ getTranslation('d019') }}</th>
                            </tr>                               
                            <tr class="table-row">
                                <td class="table-header" style="padding: 0; border: none;">
                                    <Row type="flex" style="margin: 0;">
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k241') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('b006') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('r084') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k244') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k258') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k379') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k380') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k381') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k247') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k248') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k249') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k250') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k251') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k252') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k253') }}
                                        </Col>
                                        <Col flex="1" class="table-header flex-middle">{{ getTranslation('k254') }}
                                        </Col>
                                    </Row>
                                </td>

                            </tr>
                        </thead>                        
                        
                        <!-- 占位元素，当表头固定时防止内容跳动 -->
                        <tr class="header-placeholder">
                            <td :colspan="20" :style="{ height: headerOriginalHeight + 'px' }"></td>
                        </tr>                        
                        <tbody>
                            <tr v-for="(item, index) in prodSpotModify" :key="item.id"
                                :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']">
                                <td class="table-cell  flex-middle">{{ item.create_at_string }}</td>
                                <td>{{ item.spotId }}</td>
                                <td>{{ item.userName }}</td>
                                <td v-if="item.Type == 1">
                                    <Row type="flex" :class="['table-row']">
                                        <Col class="table-cell flex-middle modified-old" flex="1">
                                        <div class="">{{ getTranslation('k239') }}</div>
                                        </Col>
                                    </Row>
                                    <Row type="flex" class="table-row">
                                        <Col class="table-cell flex-middle modified-new" flex="1">
                                        <div class="">{{ getTranslation('k240') }}</div>
                                        </Col>
                                    </Row>
                                </td>
                                <td v-else :class="['block-middle', typeClass[item.Type]]">
                                    <Row type="flex" :class="['']">
                                        <Col :class="['table-cell','flex-middle',typeClass[item.Type]]" flex="1">
                                        <div class="">{{ActionMap[item.Type]}}</div>
                                        </Col>
                                    </Row>
                                    </td>
                                <td colspan="16">
                                    <!-- 新数据行 -->
                                    <!-- 旧数据行 -->
                                    <template v-if="item.Type == 2 || item.Type == 1">
                                        <Row type="flex" class="">
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotName != jsons(item.old).spotName) }]"
                                                flex="1">{{ jsons(item.old)["spotName"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotProg != jsons(item.old).spotProg) }]"
                                                flex="1">{{ jsons(item.old).spotProg }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotPss != jsons(item.old).spotPss) }]"
                                                flex="1">{{ jsons(item.old)["spotPss"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotThk != jsons(item.old).spotThk) }]"
                                                flex="1">{{ jsons(item.old)["spotThk"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotModel != jsons(item.old).spotModel) }]"
                                                flex="1">{{ jsons(item.old)["spotModel"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotX != jsons(item.old).spotX) }]"
                                                flex="1">{{ jsons(item.old)["spotX"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotY != jsons(item.old).spotY) }]"
                                                flex="1">{{ jsons(item.old)["spotY"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).spotZ != jsons(item.old).spotZ) }]"
                                                flex="1">{{ jsons(item.old)["spotZ"] }}</Col>
                                            <Col :class="['table-cell', {'modified-old': item.Type == 1 && (jsons(item.new).plateName1 != jsons(item.old).plateName1) }]"
                                                flex="1">{{ jsons(item.old)["plateName1"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).plateThk1 != jsons(item.old).plateThk1) }]"
                                                flex="1">{{ jsons(item.old)["plateThk1"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).plateName2 != jsons(item.old).plateName2) }]"
                                                flex="1">{{ jsons(item.old)["plateName2"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).plateThk2 != jsons(item.old).plateThk2) }]"
                                                flex="1">{{ jsons(item.old)["plateThk2"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).plateName3 != jsons(item.old).plateName3) }]"
                                                flex="1">{{ jsons(item.old)["plateName3"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).plateThk3 != jsons(item.old).plateThk3) }]"
                                                flex="1">{{ jsons(item.old)["plateThk3"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).plateName4 != jsons(item.old).plateName4) }]"
                                                flex="1">{{ jsons(item.old)["plateName4"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-old': item.Type == 1 && (jsons(item.new).plateThk4 != jsons(item.old).plateThk4) }]"
                                                flex="1">{{ jsons(item.old)["plateThk4"] }}</Col>
                                        </Row>
                                    </template>
                                    <template v-if="item.Type == 0 || item.Type == 1">
                                        <Row type="flex" class="">
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotName != jsons(item.old).spotName) }]"
                                                flex="1">{{ jsons(item.new)["spotName"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotProg != jsons(item.old).spotProg) }]"
                                                flex="1">{{ jsons(item.new)["spotProg"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotPss != jsons(item.old).spotPss) }]"
                                                flex="1">{{ jsons(item.new)["spotPss"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotThk != jsons(item.old).spotThk) }]"
                                                flex="1">{{ jsons(item.new)["spotThk"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotModel != jsons(item.old).spotModel) }]"
                                                flex="1">{{ jsons(item.new)["spotModel"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotX != jsons(item.old).spotX) }]"
                                                flex="1">{{ jsons(item.new)["spotX"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotY != jsons(item.old).spotY) }]"
                                                flex="1">{{ jsons(item.new)["spotY"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).spotZ != jsons(item.old).spotZ) }]"
                                                flex="1">{{ jsons(item.new)["spotZ"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateName1 != jsons(item.old).plateName1) }]"
                                                flex="1">{{ jsons(item.new)["plateName1"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateThk1 != jsons(item.old).plateThk1) }]"
                                                flex="1">{{ jsons(item.new)["plateThk1"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateName2 != jsons(item.old).plateName2) }]"
                                                flex="1">{{ jsons(item.new)["plateName2"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateThk2 != jsons(item.old).plateThk2) }]"
                                                flex="1">{{ jsons(item.new)["plateThk2"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateName3 != jsons(item.old).plateName3) }]"
                                                flex="1">{{ jsons(item.new)["plateName3"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateThk3 != jsons(item.old).plateThk3) }]"
                                                flex="1">{{ jsons(item.new)["plateThk3"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateName4 != jsons(item.old).plateName4) }]"
                                                flex="1">{{ jsons(item.new)["plateName4"] }}</Col>
                                            <Col :class="['table-cell', { 'modified-new': item.Type == 1 && (jsons(item.new).plateThk4 != jsons(item.old).plateThk4) }]"
                                                flex="1">{{ jsons(item.new)["plateThk4"] }}</Col>
                                        </Row>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>

                    <Row type="flex">
                        <Col flex="1" class="table-cell flex-right" v-if="prodSpotModify && prodSpotModify.length > 0">
                        <Page class="page-line" :total="prodSpotTotal" :current="prodSpotCurrent"
                            :page-size="prodSpotPageSize" show-total @on-change="handleProdSpotPageChange"
                            @on-page-size-change="handleProdspotPageSizeChange" :show-sizer="true"
                            :page-size-opts=pageSizeAry>{{
                                getTranslation('c010') }} {{ prodSpotTotal }}
                            {{ getTranslation('c011') }}</Page>
                        </Col>
                    </Row>
                </TabPane>

            </Tabs>
        </div>
    </MainLayout>
</template>
<script>
import { API_URL, PAGE_SIZE_ARY } from '@/constants/const';
import MainLayout from '@/components/MainLayout.vue'
import axios from 'axios';
import { mapGetters, mapState } from 'vuex'
import { Row, Col, Button, Input, DatePicker, Page, TabPane, Tabs, Select, Option,Tooltip } from "view-design"
import { formatUTCDate, getDate, getTime, exportFile, blobToString, setSidbarBreadCrumb, postJsError,setDashboardPage } from '@/util/util.js'
import NoAuth from '@/components/NoAuth.vue'
export default {
    name: 'ModifycationIndex', // 组件名称
    components: {
        MainLayout, Row, Col, Button, Input, DatePicker, Page, NoAuth, TabPane, Tabs, Select, Option,Tooltip
    },
    watch: {
        modificationMode(newVal) {
            localStorage.setItem('modification.tab', newVal);
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        ...mapState(['queryDate']),
        ActionMap() {
            return {
                0: this.getTranslation("d017"),
                1: this.getTranslation("d018"),
                2: this.getTranslation("m027"),
            }
        },
        AllActionMap() {
            return [{
                "key": -1,
                "val": this.getTranslation("k236"),
            }, {
                "key": 0,
                "val": this.getTranslation("d017"),
            }, {
                "key": 1,
                "val": this.getTranslation("d018"),
            }, {
                "key": 2,
                "val": this.getTranslation("m027"),
            }]
        },
        typeClass() {
            return [
                'type-add',
                'type-modify',
                'type-delete'
            ]
        },
        dynamicHeightStyle(){
            let minHeight = 400;
            let calculatedHeight = window.innerHeight - 260;            
            return {
                height: `${calculatedHeight > minHeight ? calculatedHeight : minHeight}px`, // 减去页头页尾高度                
            }
        },
        querySystemConditions() {
            const conditions = [];
            const q = this.lastSystemQuery;
            if (q.selectDate && q.selectDate.length === 2) {
                conditions.push({
                label: this.getTranslation('k221'),
                value: `${formatUTCDate(q.selectDate[0])} ~ ${formatUTCDate(q.selectDate[1])}`
                });
            }
            
            if (q.programId) {
                conditions.push({ label: this.getTranslation('b006'), value: q.programId });
            }
            return conditions;
        },
        queryModifyConditions() {
            const conditions = [];
            const q = this.lastModifyQuery;

            if (q.selectDate && q.selectDate.length === 2) {
                conditions.push({
                label: this.getTranslation('k221'),
                value: `${formatUTCDate(q.selectDate[0])} ~ ${formatUTCDate(q.selectDate[1])}`
                });
            }
             if (q.spot_id !== '') {
                conditions.push({ label: this.getTranslation('k259'), value: q.spot_id });
            }
             if (q.user_name !== '') {
                conditions.push({ label: this.getTranslation('s003'), value: q.user_name });
            }            
          
            if (q.type !== '') {
                conditions.push({ label: this.getTranslation('d016'), value: this.AllActionMap.find(item => item.key === q.type)?.val || q.type });
            }
            return conditions;
        },
    },
    data() {
        return {
            modification: [],
            total: 0,
            current: 1,
            pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
            selectDate: [new Date(), new Date()],
            programId: '',
            pageSizeAry: PAGE_SIZE_ARY,
            hasAuth: true,
            modificationMode: "m1",
            spotId: '',
            prodSpotTotal: 0,
            prodSpotCurrent: 1,
            prodSpotPageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
            prodSpotModify: [],
            actionType: -1,
            operator: "",
            headerOriginalHeight: 0, // 表头原始高度（用于占位元素）
            lastSystemQuery: {
                selectDate: null,
                programId: '',              
            },
            lastModifyQuery: {
                selectDate: null,
                spot_id: '',
                user_name :"",               
                type:'',
            },
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    created() {
        setDashboardPage('modification');
        this.modificationMode = localStorage.getItem('modification.tab') || 'm1';   
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac
            if (!this.mac) {
                this.$Message.error(this.getTranslation('m041'));
                return
            }
            if (this.queryDate && this.queryDate.length > 0) {
                this.selectDate = [...this.queryDate]
            }
            this.initMachine();
            this.$nextTick(() => {
                this.getData();
                this.getProdSpotData();
            })
        },
        initMachine() {
            let url = API_URL["recordInit"];
            let params = {
                mac: this.mac
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$store.commit('setBreadcrumbItems', [
                            { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
                        ]);
                    }
                })
        },
        getData() {
            let url = API_URL["modificationGet"];
            let params = {
                page: this.current,
                page_size: this.pageSize,
                mac: this.mac,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
                program_id: this.programId == '' ? -1 : this.programId,
            }
            this.$store.commit('setQueryDate', this.selectDate)
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.lastSystemQuery= {
                            selectDate: this.selectDate ? [...this.selectDate] : null,
                            programId: this.programId,            
                        };
                        this.modification = res.data.data.data;
                        this.total = res.data.data.total;
                        this.pageSize = res.data.data.pagination.page_size;
                        this.current = res.data.data.pagination.page;

                    } else if (res && res.data && res.data.code == 3001) {
                        this.hasAuth = false;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        getProdSpotData() {
            let url = API_URL["modificationProdspotGet"];
            let params = {
                page: this.prodSpotCurrent,
                page_size: this.prodSpotPageSize,
                mac: this.mac,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
                spot_id: this.spotId == '' ? null : this.spotId,
                user_name: this.operator == "" ? null : this.operator,
                type: this.actionType,
            }
            this.$store.commit('setQueryDate', this.selectDate)
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                         this.lastModifyQuery = {
                            selectDate: this.selectDate ? [...this.selectDate] : null,
                            spot_id: this.spotId,
                            user_name : this.operator,                            
                            type: this.actionType,
                        }
                        if (res.data.data.data) {
                            this.prodSpotModify = res.data.data.data
                        } else {
                            this.prodSpotModify = []
                        }
                        this.prodSpotTotal = res.data.data.total;
                        this.prodSpotPageSize = res.data.data.pagination.page_size;
                        this.prodSpotCurrent = res.data.data.pagination.page;
                    } else if (res && res.data && res.data.code == 3001) {
                        this.hasAuth = false;
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })

        },
        queryProdSpotData(){
            this.prodSpotCurrent = 1;
            this.getProdSpotData();
        },
        getDate(str) {
            return getDate(str)
        },
        queryData(){
            this.current = 1 ;
            this.getData();
        },
        emptyQuery() {
            this.programId = "";
            this.current =1;
            this.getData();
        },
        emptyProdSpotQuery() {
            this.spotId = "";
            this.operator = "";
            this.actionType = -1;
            this.prodSpotCurrent=1;
            this.getProdSpotData();
        },
        getTime(str) {
            return getTime(str)
        },
        handlePageChange(page) {
            this.current = page;
            this.getData();
        },
        handleProdSpotPageChange(page) {
            this.prodSpotCurrent = page;
            this.getProdSpotData();
        },
        async exportRecord() {
            let params = {
                mac: this.mac,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
                program_id: this.programId == '' ? -1 : this.programId,
            }
            let exportUrl = API_URL["modificationExport"];
            const response = await axios.get(exportUrl, {
                responseType: 'blob',
                params: params,
                timeout: 300000,
            });
            if (response.status == 200) {
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                    blobToString(response.data).then(text => {
                        let msgData = JSON.parse(text);
                        if (msgData.msg) {
                            this.$Message.error(msgData.msg)
                        }
                    }).catch((err) => {
                        postJsError(err)
                        this.$Message.error(this.getTranslation('c001'));
                    });
                } else {
                    exportFile(response)
                }
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        exportSpotModification() {
            let params = {              
                mac: this.mac,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
                spot_id: this.spotId == '' ? null : this.spotId,
                user_name: this.operator == "" ? null : this.operator,
                type: this.actionType,
            }
            let exportUrl = API_URL["modificationProdspotExport"];
            axios.get(exportUrl, {
                responseType: 'blob',
                params: params,
                timeout: 300000,
            })
                .then(response => {
                    if (response.status == 200) {
                        const contentType = response.headers['content-type'];
                        if (contentType && contentType.includes('application/json')) {
                            blobToString(response.data).then(text => {
                                let msgData = JSON.parse(text);
                                if (msgData.msg) {
                                    this.$Message.error(msgData.msg)
                                }
                            }).catch((err) => {
                                postJsError(err)
                                this.$Message.error(this.getTranslation('c001'));
                            });
                        } else {
                            exportFile(response)
                        }
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
        },
        handlePageSizeChange(pageSize) {
            this.current = 1;
            this.pageSize = pageSize;
            localStorage.setItem('user.page_size', this.pageSize)
            this.getData();
        },
        handleProdspotPageSizeChange(pageSize) {
            this.prodSpotCurrent
            this.prodSpotPageSize = pageSize;
            
            localStorage.setItem('user.page_size', this.prodSpotPageSize)
            this.getProdSpotData();
        },
        jsons(item) {
            try {
                if (item) {
                    return JSON.parse(item);
                }
            } catch (err) {
                postJsError(err)
            }
            return {}
        }
    },
}
</script>

<style scoped>
@import url('../../assets/style/list.css');

.modified-old {
    color: #333;
    background-color: #ffcccc;  
}
.modified-new {
    color: #333;
    background-color: #ccffcc;   
  
}

.modification-table {
    font-size: 0.70rem;
    position: relative; /* 为absolute定位提供参考 */
}

.modification-table th,
.modification-table td {
    vertical-align: middle;
}

.type-add {     
    background-color: greenyellow;   
}

.type-delete {
    background-color: red;
    color: white;   
}

.header-placeholder {
    visibility: hidden;
}

.table-wrapper {
  position: relative;  
  overflow-y: auto;
  width: 100%;
  
}

.table-header-fixed {
   position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  width: 100%;
}

</style>
